
import { Button, Select } from 'antd';
import { Filter } from 'lucide-react';
import React from 'react';

const ChatTab = (props) => {
    const { Option } = Select;
    const { activeTab, onSelectTab } = props;
    const handleReset = () => {
        onSelectTab('active');
    };
    const tabs = [
        { label: 'Active', value: 'active' },
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'Sally', value: 'sally' },
        { label: 'Messages', value: 'message' },

        { label: 'Unread', value: 'unread' },
        { label: <Button onClick={handleReset} className="bg-red-500 text-white rounded-md px-4 py-2 cursor-pointer hover:bg-red-600">Reset</Button>, value: 'active' }

    ];

  
    return (
        <div className="flex items-center gap-2">

        <Select
            className="h-11 rounded-md bg-[#EEF5FF] text-black cursor-pointer ml-1 border-none w-auto"
            value={''}
            onChange={onSelectTab}
            placeholder={<Filter size={18} className="text-black" />}
            showArrow={true}
            suffixIcon={<Filter size={18} className="text-black" />}
            showSearch
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
            dropdownStyle={{ minWidth: '100px' }}
        >
            {tabs.map((tab) => (
                <Option
                    key={tab.value}
                    value={tab.value}
                    className={activeTab === tab.value ? 'border-none text-white bg-[#EEF5FF]' : 'bg-[white] text-black'}
                >
                    {tab.label}
                </Option>
            ))}
        </Select>
       
     </div>
    );
};

export default ChatTab;
